import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  body: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    color: '#1C2541',
  },
  primaryColumn: {
    flex: 8,
    background: '#ffffff',
    width: '100%',
  },
  header: {
    lineHeight: '44px',
    fontSize: '32px',
    fontWeight: 700,
    marginTop: '14px',
    marginBottom: '14px',
  },
  dataGridWrapper: {
    marginTop: '20px',
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'transparent',
    },
  },
  estateTaskDataGrid: {
    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
      display: 'none',
    },
    '& .estateTasksHeader': {
      backgroundColor: '#F5F5F5',
    },
    '& .checkbox-column': {
      backgroundColor: '#F5F5F5',
    },
    width: '100%',
    border: 'none',
  },
  checkbox: {
    '&.Mui-disabled': {
      '& .MuiSvgIcon-root': {
        color: 'rgba(0, 0, 0, 0.26)',
      },
    },
  },
  estateTaskHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  estateTaskHeaderName: {
    marginLeft: '8px',
  },
  deadlineText: {
    fontSize: '16px',
    color: '#9E2B25',
    display: 'flex',
    alignItems: 'center',
  },
  deadlineTableTitle: {
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '16px',
    marginTop: '16px',
  },
  editDeadlineIcon: {
    cursor: 'pointer',
  },
}));
